import React, { useState, useEffect } from 'react'
import { useSearchParams, useNavigate, useParams } from "react-router-dom";

// components
import {
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane
} from '@coreui/react-pro';
import CustomerBookingHistory from './CustomerBookingHistory';
import CustomerWishlist from './CustomerWishlist'

const AppSecondDetails = ({
  customerDetails,
  customerBookingHistory,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [activeTabKey, setActiveTabKey] = useState(null);

  const tabs = [{
    id: 1,
    label: "Booking History",
  },
    // {
    //   id: 2,
    //   label: "Wishlist",
    // }
  ];

  useEffect(() => {
    // const tabKey = parseInt(searchParams.get("tab"));
    if (!activeTabKey) {
      setActiveTabKey(1);
    }
    // else {
    //   setActiveTabKey(tabKey)
    // }
  }, []);

  const handleClicktab = (tabId) => {
    setActiveTabKey(tabId);
    // navigate(`/customers/details/list?tab=${tabId}`);
  };

  return (
    <>
      <CNav variant='underline'>
        {tabs.map((tab, index) => (
          <CNavItem key={index}>
            <CNavLink
              type="button"
              active={activeTabKey === tab.id}
              onClick={() => handleClicktab(tab.id)}
            >
              {tab.label}
            </CNavLink>
          </CNavItem>
        ))}
      </CNav>
      <CTabContent>
        <CTabPane visible={activeTabKey === 1}>
          <CustomerBookingHistory
            customerDetails={customerDetails}
            customerBookingHistory={customerBookingHistory}
          />
        </CTabPane>
        {/* <CTabPane visible={activeTabKey === 2}>
          <CustomerWishlist
            customerDetails={customerDetails}
            customerWishlist={customerWishlist}
          />
        </CTabPane> */}
      </CTabContent>
    </>
  )
}

export default AppSecondDetails
